"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PropertyCardMLSFooter = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _Image = require("../Image/Image");
var _Text = require("../Text/Text");
var _PropertyCardMLSFooter = require("./PropertyCardMLSFooter.styles");
var _excluded = ["attribution", "logoSrc"];
/**
 * [Update: Deprecated. Replaced by `PropertyCard.MLSLogo`.]
 *
 * Displays an MLS's logo and attribution text across the bottom of the photo.
 * Includes a gradient background to make the text easier to see over the photo.
 *
 * @since 8.63.0
 * @deprecated 8.64.2
 */
var PropertyCardMLSFooter = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, forwardedRef) {
  var attribution = _ref.attribution,
    logoSrc = _ref.logoSrc,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement(_PropertyCardMLSFooter.StyledPropertyCardMLSFooter, (0, _extends2.default)({
    ref: forwardedRef
  }, rest), /*#__PURE__*/_react.default.createElement(_Text.Text, null, attribution), logoSrc && /*#__PURE__*/_react.default.createElement(_Image.Image, {
    src: logoSrc,
    alt: attribution || '',
    "aria-hidden": true
  }));
});
exports.PropertyCardMLSFooter = PropertyCardMLSFooter;
PropertyCardMLSFooter.displayName = 'PropertyCard.MLSFooter';
PropertyCardMLSFooter.propTypes = {
  /**
   * The MLS attribution text. Displayed next to the MLS logo and used for alt text.
   *
   * Ex: "Listing provided by NWMLS"
   */
  attribution: _propTypes.default.string,
  /**
   * The URL for the MLS logo.
   */
  logoSrc: _propTypes.default.string
};